import React from 'react';
import { NewsfilateHeader } from '../components/NewsfilateHeader';
import { HeroSection } from '../components/HeroSection';
import { WhySection } from '../components/WhySection';
import { FeaturesSection } from '../components/FeaturesSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { DemoSection } from '../components/DemoSection';
import { PricingSection } from '../components/PricingSection';
import { CTASection } from '../components/CTASection';
import { NewsfilateFooter } from '../components/NewsfilateFooter';
export function NewsfiliatePage() {
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-1844">
      <NewsfilateHeader data-id="element-1845" />
      <main className="flex-grow" data-id="element-1846">
        <HeroSection data-id="element-1847" />
        <WhySection data-id="element-1848" />
        <FeaturesSection data-id="element-1849" />
        <TestimonialsSection data-id="element-1850" />
        <HowItWorksSection data-id="element-1851" />
        <DemoSection data-id="element-1852" />
        <PricingSection data-id="element-1853" />
        <CTASection data-id="element-1854" />
      </main>
      <NewsfilateFooter data-id="element-1855" />
    </div>;
}